import React from "react";
import styled from "styled-components";
import theme from "../../../assets/theme";
import COLORS from "../../../assets/Colors";
import CustomTable from "../../common/CustomTable/MaterialCustomTable";
import { Grid, Paper } from "@material-ui/core";
import ActionBar from "../../common/ActionBar";
import { OuterContainer } from "../../EventCreation/styles";
import { Formik } from "formik";
import FormField from "../FormInputs";
import Search from "./Search";

const ReportsTwo = () => {
  const columns = [
    {
      field: "dateTime",
      title: "Date Time",
      sorting: true,
      render: (rowData) => <Center>{rowData?.dateTime}</Center>,
      width: 350,
    },
    {
      field: "eventName",
      title: "Event Name",
      render: (rowData) => <Center>{rowData.eventName}</Center>,
      width: 250,
    },
    {
      field: "type",
      title: "Type",
      render: (rowData) => <Center>{rowData.type}</Center>,
      width: 250,
    },
    {
      field: "status",
      title: "Status",
      render: (rowData) => <Center>{rowData.status}</Center>,
      width: 250,
    },
    {
      field: "registration",
      title: "Registrations",
      render: (rowData) => <Center>{rowData.registration}</Center>,
      width: 250,
    },
    {
      field: "company",
      title: "Company",
      render: (rowData) => <Center>{rowData.company}</Center>,
      width: 250,
    },
    {
      field: "coordinator",
      title: "Coordinator",
      render: (rowData) => <Center>{rowData.coordinator}</Center>,
      width: 250,
    },
    {
      field: "action",
      title: "Action",
      render: (rowData) => (
        <div style={{ display: "flex" }}>
          <HyperLink>View</HyperLink>{" "}
          <HyperLink style={{ marginLeft: "5px" }}>Manage</HyperLink>{" "}
          <HyperLink style={{ marginLeft: "5px" }}>Cancel</HyperLink>
        </div>
      ),
      width: 250,
    },
  ];

  const data = [
    {
      dateTime: "09-Dec-24 11.54",
      eventName: "Dsnl",
      type: "AGM",
      status: "Upcoming",
      registration: "open",
      company: "ITC Infotech",
      coordinator: "saurabh",
    },
    {
      dateTime: "09-Dec-24 11.54",
      eventName: "Dsnl",
      type: "AGM",
      status: "Upcoming",
      registration: "open",
      company: "ITC Infotech",
      coordinator: "saurabh",
    },
    {
      dateTime: "09-Dec-24 11.54",
      eventName: "Dsnl",
      type: "AGM",
      status: "Upcoming",
      registration: "open",
      company: "ITC Infotech",
      coordinator: "saurabh",
    },
    {
      dateTime: "09-Dec-24 11.54",
      eventName: "Dsnl",
      type: "AGM",
      status: "Upcoming",
      registration: "open",
      company: "ITC Infotech",
      coordinator: "saurabh",
    },
    {
      dateTime: "09-Dec-24 11.54",
      eventName: "Dsnl",
      type: "AGM",
      status: "Upcoming",
      registration: "open",
      company: "ITC Infotech",
      coordinator: "saurabh",
    },
    {
      dateTime: "09-Dec-24 11.54",
      eventName: "Dsnl",
      type: "AGM",
      status: "Upcoming",
      registration: "open",
      company: "ITC Infotech",
      coordinator: "saurabh",
    },
    {
      dateTime: "09-Dec-24 11.54",
      eventName: "Dsnl",
      type: "AGM",
      status: "Upcoming",
      registration: "open",
      company: "ITC Infotech",
      coordinator: "saurabh",
    },
    {
      dateTime: "09-Dec-24 11.54",
      eventName: "Dsnl",
      type: "AGM",
      status: "Upcoming",
      registration: "open",
      company: "ITC Infotech",
      coordinator: "saurabh",
    },
    {
      dateTime: "09-Dec-24 11.54",
      eventName: "Dsnl",
      type: "AGM",
      status: "Upcoming",
      registration: "open",
      company: "ITC Infotech",
      coordinator: "saurabh",
    },
  ];

  const inputs = [
    {
      name: "date",
      label: "Date",
      type: "date",
    },
    {
      name: "companyName",
      label: "Company Name",
      type: "text",
    },
    {
      name: "eventType",
      label: "Event Type",
      type: "text",
    },
    {
      name: "registrations",
      label: "Registrations",
      type: "text",
    },
  ];
  return (
    <>
      <OuterContainer disabled={false}>
        <ActionBar
          breadcrumbs={[
            "Event Manager",
            "Manage Organizations",
            "Manage Roles",
            "Reports",
          ]}
        />
        <Container>
          <Formik
            initialValues={{
              date: "09-Dec-24 11.54",
              companyName: "Dsnl",
              eventType: "AGM",
              registrations: "Open",
              enablePassword: true,
            }}
            enableReinitialize
            onSubmit={""}
            validationSchema={""}
            validateOnBlur
            validateOnChange
          >
            {({
              values,
              errors,
              touched,
              handleBlur,
              handleSubmit,
              handleChange,
            }) => (
              <FormContainer>
                <Container>
                  <Paper
                    elevation={3}
                    style={{
                      padding: 16,
                      border: "1px solid #e1e3ee",
                      marginTop: "15px",
                      marginBottom: "5px",
                    }}
                  >
                    <Grid container spacing={2} style={{ marginTop: "16px" }}>
                      <Grid container spacing={2} style={{ marginTop: "16px" }}>
                        {inputs.map((item, index) => (
                          <Grid
                            item
                            xs={4}
                            key={item.name}
                            style={styles.gridItem}
                          >
                            <FormField
                              {...{ item, handleChange, values }}
                              width={"90px"}
                            />
                          </Grid>
                        ))}
                        <Search placeholderText={"Search"} />
                      </Grid>
                    </Grid>
                  </Paper>
                </Container>
              </FormContainer>
            )}
          </Formik>
        </Container>
      </OuterContainer>
      <Padding>
        <CustomTable
          hidePagination={data?.lastPage === 1}
          pageSize={10}
          noToolbar={false}
          {...{
            columns,
          }}
          data={data}
          hideFilterBar
          //   state={state}
        />
      </Padding>
    </>
  );
};

const styles = {
  container: {
    backgroundColor: "#A9A9A9", // gray background
    padding: "20px",
    borderRadius: "8px",
  },
  gridItem: {
    display: "flex",
    justifyContent: "space-between",
  },
  label: {
    fontWeight: "bold",
  },
};

export default ReportsTwo;

const Center = styled.span`
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 14px;
  color: #454545;
`;

export const HyperLink = styled.span`
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 14px;
  color: ${COLORS.LIGHT_BLUE_LABEL};
  text-decoration: underline;
  width: auto;
`;

const Padding = styled.div`
  padding: 30.3px 15px 15.7px 15px;
  @media ${theme?.breakpoints?.sm_up} {
    padding-top: 10px;
    padding-bottom: 50px;
    padding-left: 35px;
    padding-right: 53px;
  }
`;

const FormContainer = styled.form`
  /* width: 907px; */

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  @media ${theme?.breakpoints?.md_up} {
    width: 100%;
  }
`;

const Container = styled.div`
  padding: 20px 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  & .delete {
    display: flex;
    cursor: pointer;
  }
  @media ${theme?.breakpoints?.sm_up} {
    // padding: 34px 43px;
  }
`;
